import { FormValidation } from "react-jsonschema-form";
import { CategoryLimits } from "../../../domain/entities/CategoryLimits";
import { mapCategoryLimitsFormDataToDomain } from "../../mappers/category-limits.mapper";
import { CategoryLimitsFormData } from "../../types/CategoryLimitsTypes";
import { FormatIssue } from "./categoryLimitBlock.viewModel";

type ErrorHandler = { __errors: string[]; addError: (message: string) => void };
type ErrorNode = { [key: string]: ErrorNode } & Partial<ErrorHandler>;

const createHandler = (): ErrorHandler => ({
  __errors: [],
  addError(message: string) {
    this.__errors.push(message);
  },
});

/** rjsf only creates handlers for keys present in the form data, so a missing one is created. */
function handlerAt(errors: FormValidation, path: readonly string[]): ErrorHandler {
  let node = (errors as unknown) as ErrorNode;
  path.forEach(key => {
    node[key] = node[key] ?? ((createHandler() as unknown) as ErrorNode);
    node = node[key];
  });
  return node as ErrorHandler;
}

/**
 * Part of the page `validate`: pre-checks every block that is on (limits required, included not
 * above the maximum, at least one active extra ticked) and adds each message to
 * `errors.categoryLimits.<CATEGORY>.<field>`, which blocks only the save. Blocks that are off are
 * not validated.
 */
export function addCategoryLimitsErrors(
  errors: FormValidation,
  limits: CategoryLimits | undefined,
  formData: CategoryLimitsFormData | undefined,
  format: FormatIssue
): FormValidation {
  if (!limits?.isSectionVisible()) {
    return errors;
  }
  mapCategoryLimitsFormDataToDomain(limits, formData)
    .preCheck()
    .forEach(issue => {
      const { category, field } = issue.target;
      handlerAt(errors, ["categoryLimits", category, field ?? "block"]).addError(format(issue));
    });
  return errors;
}
